import { Injectable } from '@angular/core';
import { RequestOptions, URLSearchParams } from '@angular/http';

import { Gfo } from './common-gfo.service';
import { CommonRequestService, PagingParam } from './common-request.service';
import { UserService } from './user.service';
import { AppSettings } from './../app.settings';


// TODO
export interface LBSymbology {
	projectId: number;
	projectName: string;
	layerId: number;
	layerName: string;
	layerColumnId: number; // symbology column's id
	layerColumnName: string; // eg. AADT
	layerColumnType: string; // eg. Integer, Text, etc
	// Symbology type: Interval
	id: number;
	spec: LBSymbologySpec; // TODO
}
export interface LBCompatibleSymbology {
	spec: LBSymbologySpec;
}
// Symbology's specification including type, symbol column, symbols, etc
export interface LBSymbologySpec {
	name: string;
	labCol: string; // label column
	symCol: string; // symbol column
	tipCol: string; // tooltip column
	symbols: LBSymbol[];
	symType: LBSymbologyType;

	// ???????
	minVal?: any;
	maxVal?: any;
	reso?: any;
	div?: any;
}

//
export type LBSymbologyType = 'NOMINAL' | 'ORDINAL' | 'INTERVAL';
export interface LBSymbol {
	color: string;
	lab: string; // label
	size: number;
	style: string;
	val: any; // value ???
}

@Injectable()
export class SymbologysService {

	constructor(
		private requestService: CommonRequestService,
		private userService: UserService
	) { }
	deleteSymbology(symbologyId): Promise<any> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/symbology';
			const body = {
				symbologyId: symbologyId
			};
			const options = new RequestOptions({
				body: body
			});
			this.requestService.requestDelete(url, options, (rsp) => {
				resolve();
			}, (err) => {
				reject();
			});
		});
	}
	addSymbology(spec: LBSymbologySpec, layerId: number, symbologyColumnId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/symbology';
			const body = {
				symbologySpec: JSON.stringify(spec),
				layerId: layerId,
				symbologyColumnId: symbologyColumnId
			};
			this.requestService.requestPost(url, body, (rsp) => {
				resolve();
			}, (err) => {
				reject();
			});
		});
	}
	updateSymbology(symbologyId: number, spec: LBSymbologySpec, symbologyColumnId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/symbology';
			const body = {
				symbologySpec: JSON.stringify(spec),
				symbologyId: symbologyId,
				symbologyColumnId: symbologyColumnId
			};
			this.requestService.requestPut(url, body, () => {
				resolve();
			}, (err) => {
				reject();
			});
		});
	}

	// Get symbol value range or distinct values
	// If symbolType is INTERVAL, Value Range will be returned
	// If symbolType is NOMINAL or not passed, Distinct values will be returned
	getSymbologyValues(layerId: number, columnId: number, symbolType?: LBSymbologyType, paging?: PagingParam): Promise<any[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/symbologyValues';
			const params = new URLSearchParams();
			params.set('layerId', layerId.toString());
			params.set('columnId', columnId.toString());
			if (symbolType) {
				params.set('symbolType', symbolType);
			}
			if (!paging) {
				paging = {
					pageNumber: 0
				};
			}
			this.requestService.setParamsPaging(params, paging);
			const options = new RequestOptions({
				params: params
			});
			this.requestService.requestGet(url, options, (rsp) => {
				if (symbolType === 'INTERVAL') {
					resolve([rsp.data[0].min, rsp.data[0].max]);
				} else {
					resolve(rsp.data[0].vals);
				}
			}, (err) => {
				reject(err);
				throw err;
			});
		});
	}

	getSymbologys(lrsId?: number, layerId?: number, gfo?: Gfo, paging?: PagingParam): Promise<LBSymbology[]> {
		return new Promise((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/symbology';
			const params = new URLSearchParams();
			params.set('customerId', this.userService.getUserInfo().customerId.toString());
			if (lrsId || lrsId === 0) { params.set('lrsId', lrsId.toString()); }
			if (layerId || layerId === 0) { params.set('layerId', layerId.toString()); }
			if (gfo) { params.set('gfo', JSON.stringify(gfo)); }
			if (!paging) {
				paging = {
					pageNumber: 0 // Default: Get all pages of symbologys
				};
			}
			this.requestService.setParamsPaging(params, paging);
			const requestOptions: RequestOptions = new RequestOptions({
				params: params
			});
			this.requestService.requestGet(url, requestOptions, (rsp) => {
				const symbs = this.handleGetSymbologys(rsp.data);
				resolve(symbs);
			}, (err) => {
				reject(err);
			});
		});
	}
	private handleGetSymbologys(data: any[]): LBSymbology[] {
		const symbs: LBSymbology[] = [];
		data = data || [];
		data.forEach((d) => {
			symbs.push({
				projectId: d.prj_id,
				projectName: d.prj_name,
				layerId: d.ole_id,
				layerName: d.ole_name,
				layerColumnId: d.ols_olc_id,
				layerColumnName: d.olc_name,
				layerColumnType: d.olc_type,
				id: d.ols_id,
				spec: this.transformSymbologySpec(d.ols_spec)
			});
		});
		return symbs;
	}
	// Transform raw ols_spec data to LBSymbologySpec format
	// Param data is directly from ols_spec column
		// NOTE!!! Spec properties should stay same as the raw data passed from database. (eg data.labCol => spec.labCol).
		// If a spec property has to be different, when updating/adding a symbology, please also do a property matching instead of passing
		// the whole spec directly
	transformSymbologySpec(data): LBSymbologySpec {
		const spec: LBSymbologySpec = {
			name: null,
			labCol: null,
			symCol: null,
			tipCol: null,
			maxVal: null,
			minVal: null,
			reso: null,
			div: null,
			symbols: [],
			symType: null
		};
		if (data) {
			spec.name = data.name;
			spec.labCol = data.labCol; // this.removeColPrefix(data.labCol);
			spec.symCol = data.symCol; // this.removeColPrefix(data.symCol);
			spec.tipCol = data.tipCol; // this.removeColPrefix(data.tipCol);
			spec.maxVal = data.maxVal;
			spec.minVal = data.minVal;
			spec.reso = data.reso;
			spec.div = data.div;
			spec.symType = data.symType;
			if (data.symbols) {
				data.symbols.forEach((s) => {
					spec.symbols.push({
						color: s.color,
						lab: s.lab,
						size: s.size,
						style: s.style,
						val: s.val
					});
				});
			}
		}
		return spec;
	}
	// Remove prefix from a column name
	removeColPrefix(name: string): string {
		if (!name) { return name; }
		let nameWithoutPrefix = name;
		const idx = name.indexOf('.');
		if (idx !== -1) {
			nameWithoutPrefix = name.substr(idx + 1, name.length - idx);
		}
		return nameWithoutPrefix;
	}

	getEmptySymbol(): LBSymbol {
		return {
			color: null,
			size: null,
			style: null,
			val: null,
			lab: null
		};
	}
	// Get decimal places in a number
	getPrecision(n: number): number {
		if (!isFinite(n)) {
			return 0;
		}
		let e = 1, p = 0;
		while (Math.round(n * e) / e !== n) {
			if (!isFinite(e)) {
				debugger
			}
			e *= 10;
			p++;
		}
		return p;
	}

	// Get compatible symbologys (so that user doesn't have to define symbology from scratch)
	getSymbologyCompatible(layerId: number): Promise<LBCompatibleSymbology[]> {
		return new Promise<LBCompatibleSymbology[]>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'lbo/symbologyCompatible';
			const params = new URLSearchParams();
			params.set('layerId', layerId.toString());
			const requestOptions: RequestOptions = new RequestOptions({
				params: params
			});
			this.requestService.requestGet(url, requestOptions, (rsp) => {
				const symbs: LBCompatibleSymbology[] = [];
				if (rsp.data) {
					rsp.data.forEach((d) => {
						symbs.push({
							spec: this.transformSymbologySpec(d.ols_spec)
						});
					});
				}
				resolve(symbs);
			}, (err) => {
				resolve([]);
				throw err;
			});
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/common-services/symbologys.service.ts